import { useQuery } from "@tanstack/react-query";
import { fetchRedemptionProductDetail } from "@/api/redemption";

/**
 * Full product detail for the recipient slide-in, scoped to the gift-link token. Enabled
 * only once a product is selected (card tap); the feed's light payload lacks the detail.
 */
export function useRedemptionProductDetail(token: string, productId: string | null) {
  return useQuery({
    queryKey: ["redemption", "product-detail", token, productId],
    queryFn: () => fetchRedemptionProductDetail(token, productId as string),
    enabled: !!productId,
  });
}
